import { Box, Grid2, Typography } from '@mui/material';

import { SPREAD_LIST } from '@/data/spreads';

import SpreadCard from './SpreadCard';
import { spreadsOverviewGridSx, spreadsOverviewHeadingSx } from './SpreadsOverview.styles';

function SpreadsOverview() {
  return (
    <Box>
      <Typography variant="h4" component="h2" sx={spreadsOverviewHeadingSx}>
        Choose Your Spread
      </Typography>

      <Grid2 container spacing={2} sx={spreadsOverviewGridSx}>
        {SPREAD_LIST.map((spread) => (
          <Grid2 key={spread.key} size={{ xs: 12, sm: 6, md: 4 }}>
            <SpreadCard spread={spread} />
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
}

export default SpreadsOverview;
